import React from 'react'
import { Tooltip } from 'antd'
import { picProcess } from 'meinian-package/src/utils/image'
import { useNavigate } from 'react-router-dom'
import LogoIcon from 'image/empty/empty_card_logo.png'
import MoreFolderBtn from '../moreFolderBtn'
import './index.less'

export default ({ data, style, onUpdate, titleWidth, onInit, onLink, onCancelTop }) => {
  const navigate = useNavigate()
  const _onLink = () => {
    navigate(`/home/sample/${data.id}`)
    onLink?.()
  }
  return (
    <div className="mn-child-file-card" style={style} onClick={_onLink}>
      <img src={picProcess(data?.coverUrl) || LogoIcon} className="mn-child-file-card-image" />
      <div className="mn-child-file-card-info">
        <Tooltip title={data?.folderName}>
          <div className="title" style={{ width: titleWidth }}>
            {data?.folderName}
          </div>
        </Tooltip>
        <div className="info">
          <span>样衣</span>
          <span style={{ color: 'var(--m-text-1)', marginLeft: '2px' }}>{data?.sampleClothingNum}</span>
          <div className="line" />
          <div className="user">{data?.userName}</div>
          创建
        </div>
      </div>
      <div
        className="mn-child-file-card-hover-btn"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <MoreFolderBtn data={data} onDataChange={onInit} onUpdate={onUpdate} onCancelTop={onCancelTop} />
      </div>
    </div>
  )
}
